import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from 'react';
// Local
import AppHeader from "../Components/Header";
import Footer from "../Components/Footer";
import "./index.css";
import Listings from "../Pages/Listings/listings";
import ListingsDetails from "../Pages/Listings/listingsDetails";
import Setting from "../Pages/Setting/setting";
import Home from "../Pages/Home/home";
import Account from "../Pages/Account/account";
import Listings_Listed_With_K_Estates from "../Pages/Listings/listing_listed_with_K_estates";
import { Container } from "@mui/material";
import HomePageComp from "../Components/HomeParticle";
import AdminDashboardArea from "../Pages/AdminPanel/dashboardArea";
import AdminHeader from "../AdminComponents/Header";
import Clients from "../Pages/AdminPanel/K-Estates-Clients/Clients";
import Properties from "../Pages/AdminPanel/K-Estates-Properties/Properties";
import NotFoundPageComp from "../Components/NotFoundPageComp"

import { Switch } from '@mui/material'
import { useSelector } from "react-redux";
import AdminPrivate from "../Components/protectRoutes/AdminPrivate";
import Login from "../Pages/Login/login";
import PublicRoute from "../Components/protectRoutes/PublicRoute";
import OwnerRoute from "../Components/protectRoutes/OwnerRoute";
import AllDashboard from "../Pages/Dashboard/AllDashboard";
import Owners from "../Pages/AdminPanel/K-Estates-Clients/Owners";
import AllProperties from "../Pages/AdminPanel/K-Estates-Properties/AllProperties";
import PaymentPlan from "../AdminComponents/PaymentPlan";
import ResetPassword from "../Pages/ResetPassword";
import Developer from "../Pages/AdminPanel/Settings/Developer";
import Locations from "../Pages/AdminPanel/Settings/Locations";
import PropertyTypes from "../Pages/AdminPanel/Settings/PropertyTypes";
import ForgotPassword from "../Pages/ForgotPassword";
import HelpAndSupport from "../Pages/Support";
import PrivacyPolicy from "../Pages/ResetPassword/PrivacyPolicy";
import TermsAndConditions from "../Pages/ResetPassword/TermsAndConditions";
import DeletedOwners from "../Pages/AdminPanel/K-Estates-Clients/DeletedOwners";
import Transactions from "../Pages/AdminPanel/K-Estates-Clients/Transactions";
import ResidentialPrice from "../Pages/AdminPanel/K-Estates-Clients/ResidentialPrice";
import ResidentialProject from "../Pages/AdminPanel/K-Estates-Clients/ResidentialProject";
import ListingsDetail_Manual from "../Pages/Listings/ListingDetails_Manual";

// const userRole = 'client';
// const userRole = 'admin';

const ProjectRoutes = ({ path, open }) => {
  const userInfo = useSelector((state) => state.login.user);

  const [switchState, setSwitchState] = useState(false);
  const [userRole, setUserRole] = useState('client');

  // Function to handle switch change
  const handleSwitchChange = () => {
      setSwitchState(!switchState);
      setUserRole( !switchState? 'admin' : 'client')
  };
  return (
    <Router>
      <div className="main-container">
      {userInfo ?<>{ userInfo.role_id == 1?<AdminHeader />:<AppHeader />}
      </>:null}
      
        <Routes>
          <Route
            exact
            path="/"
            element={
              <AdminPrivate requiredRole="3" >
                <AllDashboard />
              </AdminPrivate>
            }
          />
               <Route
            path="/Transactions"
            element={
              <AdminPrivate requiredRole ="1">
                <Transactions />
              </AdminPrivate>
            }
          />

<Route
            path="/Residential"
            element={
              <AdminPrivate requiredRole ="1">
                <ResidentialPrice />
              </AdminPrivate>
            }
          />

<Route
            path="/ResidentialProjects"
            element={
              <AdminPrivate requiredRole ="1">
                <ResidentialProject />
              </AdminPrivate>
            }
          />

          <Route
            path="/PropertyTypes"
            element={
              <AdminPrivate requiredRole ="1">
                <PropertyTypes />
              </AdminPrivate>
            }
          />



           <Route
            path="/Developers"
            element={
              <AdminPrivate requiredRole ="1">
                <Developer />
              </AdminPrivate>
            }
          />

          <Route
            path="/Locations"
            element={
              <AdminPrivate requiredRole ="1">
                <Locations />
              </AdminPrivate>
            }
          />
         
          <Route
            path="/Properties"
            element={
              <AdminPrivate requiredRole ="1">
                <AllProperties />
              </AdminPrivate>
            }
          />

          <Route
            path="/Clients"
            element={
              <AdminPrivate requiredRole ="1">
                <Owners />
              </AdminPrivate>
            }
          />

<Route
            path="/Deleted-Clients"
            element={
              <AdminPrivate requiredRole ="1">
                <DeletedOwners />
              </AdminPrivate>
            }
          />

          <Route
            path="/Payments-Plan"
            element={
              <AdminPrivate requiredRole ="1">
                <PaymentPlan />
              </AdminPrivate>
            }
          />

          {/* owners routes */}

          <Route
            path="/Listings"
            element={
              <AdminPrivate requiredRole ="2">
                <Listings />
              </AdminPrivate>
            }
          />

          <Route
            path="/Listings_Listed_With_K_Estaes"
            element={
              <AdminPrivate requiredRole ="2">
                <Listings_Listed_With_K_Estates />
              </AdminPrivate>
            }
          />
          
          <Route
            path="/ListingsDetails"
            element={
              <AdminPrivate requiredRole ="2">
                <ListingsDetails />
              </AdminPrivate>
            }
          />

          {/** HERE ARE MANUAL */}
          <Route
            // path="/ListingsDetail_Manual"
            path="/Listing_Detail"
            element={
              <AdminPrivate requiredRole ="2">
                <ListingsDetail_Manual />
              </AdminPrivate>
            }
          />

          <Route
            path="/Setting"
            element={
              <AdminPrivate requiredRole ="2">
                <Setting />
              </AdminPrivate>
            }
          />
          <Route
            path="/Account"
            element={
              <AdminPrivate requiredRole ="2">
                <Account />
              </AdminPrivate>
            }
          />
          <Route
            path="/HelpAndSupport"
            element={
              <AdminPrivate requiredRole ="2">
                <HelpAndSupport />
              </AdminPrivate>
            }
          />
          <Route
            path="/Reset_Password"
            element={
              <AdminPrivate requiredRole ="3">
                <ResetPassword />
              </AdminPrivate>
            }
          />

          <Route
            path="/Privacy_Policy"
            element={
              <AdminPrivate requiredRole ="3">
                <PrivacyPolicy />
              </AdminPrivate>
            }
          />

          <Route
            path="/TermsAndConditions"
            element={
              <AdminPrivate requiredRole ="3">
                <TermsAndConditions />
              </AdminPrivate>
            }
          />
          

          <Route
            path="/Forgot_Password"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />

          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          


{/* <Route exact path="*" element={<NotFoundPageComp />} /> */}
      
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default ProjectRoutes;
